import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "transaction-fee-note__value text-align-right"
}

import { type PropType } from 'vue';

import { type ModalVariant } from '@exchange/libs/modals/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionFeeNote',
  props: {
  texts: { type: Array as PropType<Array<{ text: string; value: string; info?: string }>>, required: false },
  variant: { type: String as PropType<ModalVariant>, required: true },
},
  setup(__props) {



const getTooltip = (info: string) => ({
  content: info,
  theme: 'tooltip-coin-network',
  placement: 'right',
});

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["transaction-fee-note", [`transaction-fee-note--${__props.variant}`]])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.texts, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.text,
        class: "transaction-fee-note__item"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["transaction-fee-note__label text-align-left", { 'transaction-fee-note__label--with-info': item.info }])
        }, [
          _createElementVNode("div", null, _toDisplayString(item.text), 1),
          (item.info)
            ? _withDirectives((_openBlock(), _createBlock(_component_ot_icon, {
                key: 0,
                class: "transaction-fee-note__info-icon",
                name: "info-circle"
              }, null, 512)), [
                [_directive_tooltip, getTooltip(item.info)]
              ])
            : _createCommentVNode("", true)
        ], 2),
        (item.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(item.value), 1))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 2))
}
}

})